import * as Types from '../../../gql/base-types';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';

// =============================================================================
// Auto-generated by GraphQL Codegen - DO NOT EDIT
// Change the .gql source (or the schema) and re-run: pnpm codegen
// =============================================================================

const defaultOptions = {} as const;
export type GetMoveDetailsQueryVariables = Types.Exact<{
  moveId: Types.Scalars['bigint']['input'];
}>;


export type GetMoveDetailsQuery = { __typename?: 'query_root', moves_by_pk?: { __typename?: 'moves', id: number, active: number, cancel_reason?: string | null, cancel_status?: string | null, config?: object | null, customer_id?: number | null, consumer_at_pickup: number, consumer_name?: string | null, consumer_phone?: string | null, consumer_pickup?: boolean | null, consumer_type?: string | null, dealer_contact?: string | null, deliver_by?: string | null, delivery_arrived?: string | null, delivery_started?: string | null, delivery_stop_id?: string | null, delivery_successful?: string | null, delivery_time?: string | null, delivery_workflow_data?: object | null, driver_app_version?: string | null, driver_id?: number | null, driver_name?: string | null, driver_status?: string | null, lite: boolean, manual_flag: boolean, move_details?: string | null, move_type: string, payer_id?: number | null, pickup_arrived?: string | null, pickup_started?: string | null, pickup_stop_id?: string | null, pickup_successful?: string | null, pickup_time?: string | null, pickup_workflow_data?: object | null, ready_by?: string | null, reference_num?: string | null, status?: string | null, tags?: string | null, tracking_link?: string | null, usecase_key?: string | null, vehicle_color?: string | null, vehicle_make?: string | null, vehicle_model?: string | null, vehicle_odometer?: string | null, vehicle_stock?: string | null, vehicle_vin?: string | null, vehicle_year?: string | null, archarges?: Array<{ __typename?: 'archarges', id: number }> | null, accountsReceivable?: { __typename?: 'armoves', invoice: { __typename?: 'arinvoices', id: number, accounting_num?: string | null, end_datetime: string, start_datetime: string, status: string, arpayments: Array<{ __typename?: 'arpayments', id: number, accounting_id?: string | null, amount: number, createdat?: string | null, gateway_transaction_id?: string | null, status: string }>, armoves: Array<{ __typename?: 'armoves', id: number, accounting_item_id?: string | null, active: number, arevent_id: string, author: string, billable_datetime: string, discount_amount: number, discount_reason?: string | null, dispute_reason?: string | null, disputed: boolean, due_amount: number, invoice_id: number, move_id?: number | null, notes: string, paid_amount: number, status: string, type: string, details: Array<{ __typename?: 'armovedetails', id: number, amount: number, name: string, notes: string }>, invoice: { __typename?: 'arinvoices', id: number, accounting_num?: string | null, customer?: { __typename?: 'customers', id: number, accounting_id?: string | null } | null }, move?: { __typename?: 'moves', id: number, chargeable: boolean, class?: string | null, consumer_name?: string | null, customer_id?: number | null, delivery_arrived?: string | null, delivery_started?: string | null, delivery_stop_id?: string | null, delivery_successful?: string | null, pickup_arrived?: string | null, pickup_started?: string | null, pickup_successful?: string | null, reference_num?: string | null, status?: string | null, vehicle_color?: string | null, vehicle_make?: string | null, vehicle_model?: string | null, vehicle_odometer?: string | null, vehicle_stock?: string | null, vehicle_vin?: string | null, vehicle_year?: string | null, lane?: { __typename?: 'lanes', id: number, duration_sec?: number | null, dealer_base_discount?: number | null, dealer_stranded_discount?: number | null, description?: string | null, distance_miles?: number | null, tolls?: number | null, delivery: { __typename?: 'locations', id: number, address?: string | null, name?: string | null }, pickup: { __typename?: 'locations', id: number, address?: string | null, name?: string | null } } | null, raterule?: { __typename?: 'move_raterule', id?: number | null, rate?: number | null, type?: string | null } | null, customer?: { __typename?: 'customers', id: number, address?: string | null, auto_pay: boolean, billing_frequency: string, name?: string | null, payment_terms: number } | null } | null, revisions: Array<{ __typename?: 'armoveshistory', id: number, discount_amount: number, discount_reason?: string | null, dispute_reason?: string | null, disputed: boolean, due_amount: number, revision: number, details: Array<{ __typename?: 'armovedetailshistory', id: number, amount: number, name: string, notes: string }> }> }>, customer?: { __typename?: 'customers', id: number, address?: string | null, auto_pay: boolean, billing_frequency: string, name?: string | null, notify_billing?: boolean | null, payment_terms: number, paymentmethods: Array<{ __typename?: 'arpaymentmethods', id: number }> } | null } } | null, childMoves: Array<{ __typename?: 'moves', id: number, active: number, cancel_status?: string | null, consumer_name?: string | null, consumer_phone?: string | null, consumer_type?: string | null, createdat?: string | null, createdBy?: string | null, delivery_time?: string | null, driver_status?: string | null, lite: boolean, manual_flag: boolean, move_type: string, parent_move_id?: number | null, pickup_time?: string | null, reference_num?: string | null, ride_type?: string | null, status?: string | null, usecase_key?: string | null, vehicle_color?: string | null, vehicle_make?: string | null, vehicle_model?: string | null, vehicle_stock?: string | null, vehicle_vin?: string | null, vehicle_year?: string | null, eventlogs: Array<{ __typename?: 'eventlogs', id: number, user: string }>, hangtags: Array<{ __typename?: 'hangtags', id: number, hash_id: string, rear_code?: string | null, status: string, workflow_data?: object | null }>, lane?: { __typename?: 'lanes', id: number, distance_miles?: number | null, duration_sec?: number | null, description?: string | null, pickup: { __typename?: 'locations', id: number, name?: string | null, address?: string | null, latitude?: number | null, longitude?: number | null, timezone?: string | null }, delivery: { __typename?: 'locations', id: number, name?: string | null, address?: string | null, latitude?: number | null, longitude?: number | null } } | null }>, customer?: { __typename?: 'customers', id: number, config?: object | null, name?: string | null, organization?: { __typename?: 'organizations', config?: object | null } | null } | null, delivery_photos: Array<{ __typename?: 'vehiclephotos', id: string, location?: object | null, name: string, step_id: string, url?: string | null }>, driver?: { __typename?: 'drivers', id: number, user?: { __typename?: 'users', id: number, avatar_url?: string | null, display_name: string } | null } | null, lane?: { __typename?: 'lanes', id: number, duration_sec?: number | null, distance_miles?: number | null, delivery: { __typename?: 'locations', id: number, address?: string | null, latitude?: number | null, longitude?: number | null, name?: string | null, region?: { __typename?: 'regions', id: number, name: string } | null }, pickup: { __typename?: 'locations', id: number, address?: string | null, latitude?: number | null, longitude?: number | null, name?: string | null, timezone?: string | null, region?: { __typename?: 'regions', id: number, name: string } | null } } | null, parentMove?: { __typename?: 'moves', id: number, active: number, cancel_status?: string | null, consumer_name?: string | null, consumer_phone?: string | null, consumer_type?: string | null, createdat?: string | null, createdBy?: string | null, delivery_time?: string | null, lite: boolean, manual_flag: boolean, move_type: string, parent_move_id?: number | null, pickup_time?: string | null, reference_num?: string | null, status?: string | null, usecase_key?: string | null, vehicle_color?: string | null, vehicle_make?: string | null, vehicle_model?: string | null, vehicle_stock?: string | null, vehicle_vin?: string | null, vehicle_year?: string | null, eventlogs: Array<{ __typename?: 'eventlogs', id: number, user: string }>, hangtags: Array<{ __typename?: 'hangtags', id: number, hash_id: string, rear_code?: string | null, status: string, workflow_data?: object | null }>, lane?: { __typename?: 'lanes', id: number, duration_sec?: number | null, description?: string | null } | null } | null, payer?: { __typename?: 'customers', id: number, name?: string | null } | null, pickup_photos: Array<{ __typename?: 'vehiclephotos', id: string, location?: object | null, name: string, step_id: string, url?: string | null }>, scenariotomoves: Array<{ __typename?: 'scenariotomoves', scenario: { __typename?: 'scenarios', id: number, bundletoscenarios: Array<{ __typename?: 'bundletoscenarios', bundle: { __typename?: 'bundles', id: number, offers: Array<{ __typename?: 'offers', id: number, status: string, driver: { __typename?: 'drivers', id: number, user?: { __typename?: 'users', display_name: string, avatar_url?: string | null } | null } }> } }> } }>, workflowset?: { __typename?: 'workflowsets', id: number, name: string, deliveryWorkflow?: { __typename?: 'workflows', id: number, steps: object } | null, fuelWorkflow?: { __typename?: 'workflows', id: number, steps: object } | null, pickupWorkflow?: { __typename?: 'workflows', id: number, steps: object } | null } | null } | null };


export const GetMoveDetailsDocument = gql`
    query getMoveDetails($moveId: bigint!) {
  moves_by_pk(id: $moveId) {
    id
    active
    cancel_reason
    cancel_status
    config
    customer_id
    consumer_at_pickup
    consumer_name
    consumer_phone
    consumer_pickup
    consumer_type
    dealer_contact
    deliver_by
    delivery_arrived
    delivery_started
    delivery_stop_id
    delivery_successful
    delivery_time
    delivery_workflow_data
    driver_app_version
    driver_id
    driver_name
    driver_status
    lite
    manual_flag
    move_details
    move_type
    payer_id
    pickup_arrived
    pickup_started
    pickup_stop_id
    pickup_successful
    pickup_time
    pickup_workflow_data
    ready_by
    reference_num
    status
    tags
    tracking_link
    usecase_key
    vehicle_color
    vehicle_make
    vehicle_model
    vehicle_odometer
    vehicle_stock
    vehicle_vin
    vehicle_year
    archarges(
      where: {active: {_eq: true}, argroup: {status: {_eq: "done"}, arinvoice: {id: {_is_null: false}}}}
      limit: 1
    ) {
      id
    }
    accountsReceivable {
      invoice {
        id
        accounting_num
        end_datetime
        start_datetime
        status
        arpayments(order_by: {createdat: asc}) {
          id
          accounting_id
          amount
          createdat
          gateway_transaction_id
          status
        }
        armoves(
          where: {active: {_eq: 1}, type: {_eq: "move"}, move_id: {_eq: $moveId}}
          order_by: {move_id: asc}
        ) {
          id
          accounting_item_id
          active
          arevent_id
          author
          billable_datetime
          discount_amount
          discount_reason
          dispute_reason
          disputed
          due_amount
          invoice_id
          move_id
          notes
          paid_amount
          status
          type
          details {
            id
            amount
            name
            notes
          }
          invoice {
            id
            accounting_num
            customer {
              id
              accounting_id
            }
          }
          move {
            id
            chargeable
            class
            consumer_name
            customer_id
            delivery_arrived
            delivery_started
            delivery_stop_id
            delivery_successful
            pickup_arrived
            pickup_started
            pickup_successful
            reference_num
            status
            vehicle_color
            vehicle_make
            vehicle_model
            vehicle_odometer
            vehicle_odometer
            vehicle_stock
            vehicle_vin
            vehicle_year
            lane {
              id
              duration_sec
              dealer_base_discount
              dealer_stranded_discount
              description
              distance_miles
              tolls
              delivery {
                id
                address
                name
              }
              pickup {
                id
                address
                name
              }
            }
            raterule {
              id
              rate
              type
            }
            customer {
              id
              address
              auto_pay
              billing_frequency
              name
              payment_terms
            }
          }
          revisions(order_by: {revision: desc}) {
            id
            discount_amount
            discount_reason
            dispute_reason
            disputed
            due_amount
            revision
            details {
              id
              amount
              name
              notes
            }
          }
        }
        customer {
          id
          address
          auto_pay
          billing_frequency
          name
          notify_billing
          payment_terms
          paymentmethods(where: {type: {_eq: "manual"}}) {
            id
          }
        }
      }
    }
    childMoves {
      id
      active
      cancel_status
      consumer_name
      consumer_phone
      consumer_type
      createdat
      createdBy
      delivery_time
      driver_status
      lite
      manual_flag
      move_type
      parent_move_id
      pickup_time
      reference_num
      ride_type
      status
      usecase_key
      vehicle_color
      vehicle_make
      vehicle_model
      vehicle_stock
      vehicle_vin
      vehicle_year
      eventlogs {
        id
        user
      }
      hangtags {
        id
        hash_id
        rear_code
        status
        workflow_data
      }
      lane {
        id
        distance_miles
        duration_sec
        description
        pickup {
          id
          name
          address
          latitude
          longitude
          timezone
        }
        delivery {
          id
          name
          address
          latitude
          longitude
        }
      }
    }
    customer {
      id
      config
      name
      organization {
        config
      }
    }
    delivery_photos: vehiclephotos(where: {workflow: {type: {_eq: "delivery"}}}) {
      id
      location
      name
      step_id
      url
    }
    driver {
      id
      user {
        id
        avatar_url
        display_name
      }
    }
    lane {
      id
      duration_sec
      distance_miles
      delivery {
        id
        address
        latitude
        longitude
        name
        region {
          id
          name
        }
      }
      pickup {
        id
        address
        latitude
        longitude
        name
        region {
          id
          name
        }
        timezone
      }
    }
    parentMove {
      id
      active
      cancel_status
      consumer_name
      consumer_phone
      consumer_type
      createdat
      createdBy
      delivery_time
      lite
      manual_flag
      move_type
      parent_move_id
      pickup_time
      reference_num
      status
      usecase_key
      vehicle_color
      vehicle_make
      vehicle_model
      vehicle_stock
      vehicle_vin
      vehicle_year
      eventlogs {
        id
        user
      }
      hangtags {
        id
        hash_id
        rear_code
        status
        workflow_data
      }
      lane {
        id
        duration_sec
        description
      }
    }
    payer {
      id
      name
    }
    pickup_photos: vehiclephotos(where: {workflow: {type: {_eq: "pickup"}}}) {
      id
      location
      name
      step_id
      url
    }
    scenariotomoves(
      where: {scenario: {status: {_neq: "deprecated"}}}
      order_by: {id: desc}
    ) {
      scenario {
        id
        bundletoscenarios(
          where: {bundle: {status: {_in: ["ready", "dispatching", "dispatched"]}}}
          order_by: {id: desc}
        ) {
          bundle {
            id
            offers(
              where: {status: {_in: ["offered", "accepted", "assigned"]}}
              order_by: {id: desc}
            ) {
              id
              status
              driver {
                id
                user {
                  display_name
                  avatar_url
                }
              }
            }
          }
        }
      }
    }
    workflowset {
      id
      name
      deliveryWorkflow {
        id
        steps
      }
      fuelWorkflow {
        id
        steps
      }
      pickupWorkflow {
        id
        steps
      }
    }
  }
}
    `;

/**
 * __useGetMoveDetailsQuery__
 *
 * To run a query within a React component, call `useGetMoveDetailsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetMoveDetailsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetMoveDetailsQuery({
 *   variables: {
 *      moveId: // value for 'moveId'
 *   },
 * });
 */
export function useGetMoveDetailsQuery(baseOptions: Apollo.QueryHookOptions<GetMoveDetailsQuery, GetMoveDetailsQueryVariables> & ({ variables: GetMoveDetailsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetMoveDetailsQuery, GetMoveDetailsQueryVariables>(GetMoveDetailsDocument, options);
      }
export function useGetMoveDetailsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetMoveDetailsQuery, GetMoveDetailsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetMoveDetailsQuery, GetMoveDetailsQueryVariables>(GetMoveDetailsDocument, options);
        }
// @ts-ignore
export function useGetMoveDetailsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetMoveDetailsQuery, GetMoveDetailsQueryVariables>): Apollo.UseSuspenseQueryResult<GetMoveDetailsQuery, GetMoveDetailsQueryVariables>;
export function useGetMoveDetailsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetMoveDetailsQuery, GetMoveDetailsQueryVariables>): Apollo.UseSuspenseQueryResult<GetMoveDetailsQuery | undefined, GetMoveDetailsQueryVariables>;
export function useGetMoveDetailsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetMoveDetailsQuery, GetMoveDetailsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetMoveDetailsQuery, GetMoveDetailsQueryVariables>(GetMoveDetailsDocument, options);
        }
export type GetMoveDetailsQueryHookResult = ReturnType<typeof useGetMoveDetailsQuery>;
export type GetMoveDetailsLazyQueryHookResult = ReturnType<typeof useGetMoveDetailsLazyQuery>;
export type GetMoveDetailsSuspenseQueryHookResult = ReturnType<typeof useGetMoveDetailsSuspenseQuery>;
export type GetMoveDetailsQueryResult = Apollo.QueryResult<GetMoveDetailsQuery, GetMoveDetailsQueryVariables>;
import { resolveExecutor, type GqlExecutor, type GqlRequestOptions } from '@hopdrive/sdk-core'


/**
 * @source {@link src/features/moves/queries/getMoveDetails.query.gql}
 */
export async function getMoveDetails(
  variables: GetMoveDetailsQueryVariables,
  options?: { executor?: GqlExecutor; raw?: false } & GqlRequestOptions
): Promise<GetMoveDetailsQuery['moves_by_pk']>
export async function getMoveDetails(
  variables: GetMoveDetailsQueryVariables,
  options?: { executor?: GqlExecutor; raw: true } & GqlRequestOptions
): Promise<GetMoveDetailsQuery>
export async function getMoveDetails(
  variables: GetMoveDetailsQueryVariables,
  options?: { executor?: GqlExecutor; raw?: boolean } & GqlRequestOptions
): Promise<GetMoveDetailsQuery['moves_by_pk'] | GetMoveDetailsQuery> {
  const { executor, raw, ...requestOptions } = options ?? {}
  const result = await resolveExecutor(executor).query<GetMoveDetailsQuery>(
    GetMoveDetailsDocument,
    variables,
    requestOptions
  )
  if (raw) return result
  return result.moves_by_pk
}